/*
 * "Happy to help" — a quiet note for someone who has just taken a piece out of
 * their bag. Removing something often means a doubt (size, fabric, price,
 * delivery) that one answer would settle, so we offer the answer and step back.
 *
 * Deliberately low-key:
 *   - no overlay; the shopper can keep using the cart while it's there;
 *   - fades away by itself after a short while (paused while they're
 *     hovering or reading it);
 *   - at most once per visit, and if it has shown, the "before you go" note
 *     stays quiet for the rest of the visit too — one nudge is plenty.
 *
 * How a removal is spotted: a click on a cart remove button, or a quantity
 * field set to 0, marks the next cart update as a removal. Dawn publishes that
 * update on its pub/sub bus once the cart has actually changed, so the note
 * never appears for a removal that failed.
 */
(function () {
  'use strict';

  var card = document.querySelector('[data-mz-cart-help]');
  if (!card) return;

  var SEEN_KEY = 'mz_cart_help_seen';
  var EXIT_KEY = 'mz_cart_exit_seen';
  var SHOW_DELAY_MS = 700;
  var STAY_MS = 14000;

  var removalPending = false;
  var hideTimer = null;
  var hovering = false;

  function storage(fn) {
    try {
      return fn(window.sessionStorage);
    } catch (e) {
      return null;
    }
  }

  function seen() {
    return storage(function (s) { return s.getItem(SEEN_KEY); }) === '1';
  }

  function markSeen() {
    storage(function (s) {
      s.setItem(SEEN_KEY, '1');
      s.setItem(EXIT_KEY, '1');
    });
  }

  function exitNoteOpen() {
    var exit = document.getElementById('MzCartExit');
    return !!(exit && !exit.hidden);
  }

  function hide() {
    clearTimeout(hideTimer);
    if (card.hidden) return;
    card.classList.add('is-leaving');
    setTimeout(function () {
      card.hidden = true;
      card.classList.remove('is-leaving');
    }, 350);
  }

  function scheduleHide() {
    clearTimeout(hideTimer);
    hideTimer = setTimeout(function () {
      if (hovering || card.contains(document.activeElement)) {
        scheduleHide();
        return;
      }
      hide();
    }, STAY_MS);
  }

  function show() {
    if (seen() || exitNoteOpen()) return;
    markSeen();
    card.hidden = false;
    scheduleHide();
  }

  // A removal is about to happen.
  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (target && target.closest && target.closest('cart-remove-button')) removalPending = true;
    },
    true
  );
  document.addEventListener(
    'change',
    function (event) {
      var target = event.target;
      if (
        target &&
        target.matches &&
        target.matches('cart-items input[name="updates[]"], cart-drawer-items input[name="updates[]"], .cart-item input.quantity__input') &&
        parseInt(target.value, 10) === 0
      ) {
        removalPending = true;
      }
    },
    true
  );

  // ...and the cart confirms it happened.
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
      if (!removalPending) return;
      removalPending = false;
      if (!event || event.source !== 'cart-items') return;
      setTimeout(show, SHOW_DELAY_MS);
    });
  }

  card.addEventListener('mouseenter', function () { hovering = true; });
  card.addEventListener('mouseleave', function () { hovering = false; });
  card.addEventListener('click', function (event) {
    if (event.target.closest('[data-mz-help-close]')) hide();
  });
  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') hide();
  });
})();
